export const JOB_LIST_SET = 'JOB_LIST_SET'
export const JOB_LIST_LOAD = 'JOB_LIST_LOAD'
export const JOB_LIST_SUCCESS = 'JOB_LIST_SUCCESS'
export const JOB_LIST_FAILED = 'JOB_LIST_FAILED'
export const JOB_LIST_CLEAR = 'JOB_LIST_CLEAR'
